module.exports = {
  webinars: 'Webinars',
  sure_to_leave: 'Do you want to leave the webinar?',
  recordings: 'Recordings',
  leave: 'Leave Webinar',
  open_app_new_window: 'Open Learning Software in new window',
  search_webinar: 'Find a webinar',
  learningrooms: 'Learning rooms',
  webinar: 'Webinar',
  learningroom: 'Learning room',
  currently_no_webinars_visible: 'There are currently no webinars here.',
  currently_no_learningrooms_visible: 'There are currently no learning rooms here.',
  sortLabels: {
    topic_asc: 'Alphabetically (A-Z)',
    topic_desc: 'Alphabetically (Z-A)',
    starts_at_desc: 'Date (newest first)',
    starts_at_asc: 'Date (oldest first)',
  },
  sortShortLabels: {
    topic_asc: 'A-Z',
    topic_desc: 'Z-A',
    starts_at_desc: 'Newest',
    starts_at_asc: 'Oldest',
  },
  participants: '1 participant | %{n} participants',
  live: 'Live now',
  open: 'Opened',
  leave_title: 'Leave webinar',
  join_webinar: 'Join webinar',
  join_learningroom: 'Enter learning room',
  active_webinars: 'Current',
  recordings_title: 'Recordings from previous webinars',
  date_range: '%{date} - %{startTime} to %{endTime}',
}
